module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAAABCAYAAACBplZFAAAAKElEQVQ4T2O8efNmPQMWoK6u3ggSHpUfDZ/R9IEZAqP5Y7R8wFY+AgCNYasMG5q2CgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dash-line.png
// module id = m8mr
// module chunks = 1